import React from 'react';
import PropTypes from 'prop-types';
import {GelDragDropContext, useGelDragDrop} from './GelDragDrop.utils';
import {THEME} from './GelDragDrop.constants';
import {Title} from './Title';
import {Table} from './Table';
import './style.scss';

export function GelDragDrop(props) {
  const setTheme = () => {
    if (props.theme === THEME.DARK) return '';
    else return props.theme.toLowerCase();
  };

  return (
    <GelDragDropContext.Provider value={useGelDragDrop(props)}>
      <div className={`${setTheme()} gelDragDrop`} style={props.style}>
        <Title title={props.title} />
        <Table table={props.gelTable} useAbbrevLabel={props.useAbbrevLabel} resultComparison={props.resultComparison} altText={props.altText} />
      </div>
    </GelDragDropContext.Provider>
  );
}

GelDragDrop.propTypes = {
  /**
   * Title instruction to show on top of gel table
   */
  title: PropTypes.string,
  /**
   * High/Low values of Gel Table Ladders
   */
  gelRange: PropTypes.shape({
    /**
     * The lowest Ladder value
     */
    bottom: PropTypes.number,
    /**
     * The highest Ladder value
     */
    top: PropTypes.number,
  }),
  /**
   * Data for gel table
   */
  gelTable: PropTypes.arrayOf(PropTypes.object),
  /**
   *  Function to invoke on Gel position update
   */
  onGelUpdate: PropTypes.func,
  /**
   * Function to invoke when a Gel band is clicked to select it
   */
  onGelSelect: PropTypes.func,
  /**
   * Style object to set on application wrapper
   */
  style: PropTypes.object,
  /**
   * Theme for the component
   */
  theme: PropTypes.oneOf(['LIGHT', 'DARK']),
};

GelDragDrop.defaultProps = {
  style: {},
  theme: THEME.DARK,
};
